import { render, staticRenderFns } from "./sectionLayout.vue?vue&type=template&id=a7115924&scoped=true&"
import script from "./sectionLayout.vue?vue&type=script&lang=js&"
export * from "./sectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7115924",
  null
  
)

export default component.exports